export default __webpack_public_path__ + "static/media/direct-ribbon.5c6fe276.svg";